import { render, staticRenderFns } from "./dormApplication.vue?vue&type=template&id=3a95ca57"
import script from "./dormApplication.vue?vue&type=script&lang=js"
export * from "./dormApplication.vue?vue&type=script&lang=js"
import style0 from "./dormApplication.vue?vue&type=style&index=0&id=3a95ca57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports